var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.innerText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }